export const flightReservedSeatRequestType: any = {
  none: "希望しない",
  request_only_free: "無料のときのみ希望",
  request_with_fee: "有料でも希望",
};
